<template>
  <div class="edit">
    <Header :title="'相册管理'" />
    <ul>
      <li class="album-cover">
        <div class="bold">相册封面</div>
        <van-uploader
          v-model="fileList"
          :after-read="afterRead"
          :before-read="beforeRead"
          :max-count="1"
          :max-size="1024 * 1024 * 5"
          @oversize="onOversize"
        />
      </li>
      <li class="album-title">
        <div class="bold">相册名称</div>
        <nut-textbox
          v-model="album.name"
          :limit-show="false"
          :max-num="10"
          :switch-max="true"
          :txt-area-h="20"
        />
      </li>
      <li class="album-info">
        <div class="bold">相册信息</div>
        <nut-textbox
          v-model="album.information"
          :limit-show="false"
          :max-num="20"
          :switch-max="true"
          :txt-area-h="20"
        />
      </li>
    </ul>
    <div class="btn-wrappper">
      <div class="btn btn-cancel" @click="cancel">取消</div>
      <div class="btn btn-edit" @click="confirm">确定</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Header from '@/components/Header/Index'
import { Toast, Uploader } from 'vant'
import { editHallAlbum } from '@/api/Personal/Hall'
import { uploadImg } from '@/api/Comm'
import Storage from '@/utils/storage'

Vue.use(Uploader)

export default {
  name: 'Edit',
  components: {
    Header
  },
  data() {
    return {
      fileList: [
        {
          url: ''
        }
      ],
      album: {},
      cover: ''
    }
  },
  created() {
    this.album = Storage.localGet('albumDetail')
    this.fileList[0].url = this.album.thumbnail
  },
  methods: {
    cancel() {
      this.$router.back()
    },
    confirm() {
      if (this.album.thumbnail !== '' && this.album.name !== '' && this.album.information !== '') {
        editHallAlbum(this.album.id, this.album.name, this.album.information, this.cover).then(res => {
          if (res.success) {
            this.album.thumbnail = this.$resUrl(this.cover)
            Storage.localSet('albumDetail', this.album)
            Toast.success('编辑成功', {
              duration: 500
            })
            setTimeout(() => {
              this.$router.back()
            }, 500)
          }
        })
      } else {
        Toast.fail('请填写基本信息')
      }
    },
    beforeRead(file) {
      const regex = /(.jpg|.jpeg|.png|.bmp)$/
      if (!regex.test(file.type)) {
        Toast.fail('图片格式不支持上传')
        return false
      } else {
        return true
      }
    },
    afterRead(file) {
      file.status = 'uploading'
      file.message = '上传中···'
      uploadImg(file.file, 'Albums').then(res => {
        if (res.success) {
          this.cover = res.data.url
          this.album.thumbnail = this.$resUrl(this.cover)
          file.status = 'done'
          file.message = '上传成功'
        } else {
          file.status = 'failed'
          file.message = '上传失败'
        }
      })
    },
    onOversize() {
      Toast.fail('文件大小不能超过 5M')
    }
  }
}
</script>

<style lang='scss' scoped>
.edit {
  padding-top: 15px;
}

ul {
  margin: 0 15px;

  li {
    margin-bottom: 15px;

    > div:first-child {
      margin-bottom: 5px;
    }
  }
}

.nut-textbox {
  ::v-deep .txt-area {
    font-size: 14px;
    border-radius: 5px;
    overflow: hidden;
  }

  ::v-deep .txt-area.error {
    border: 1px solid $primary-color-bright;

    span {
      color: $primary-color-bright;
    }
  }
}

.van-uploader {
  ::v-deep .van-uploader__file {
    width: 110px;
    height: 110px;
    border-radius: 5px;
  }

  ::v-deep .van-uploader__upload {
    width: 166px;
    height: 166px;
    border-radius: 5px;
    overflow: hidden;
  }

  ::v-deep .van-image {
    width: 166px;
    height: 166px;
    border-radius: 5px;
    overflow: hidden;
  }

  ::v-deep .van-uploader__mask {
    border-radius: 5px;
    overflow: hidden;
  }

  ::v-deep .van-uploader__preview-delete {
    width: 25px;
    height: 25px;
    border-radius: 0 5px 0 100%;
  }

  ::v-deep .van-uploader__preview-delete-icon {
    font-size: 24px;
  }
}

.btn-wrappper {
  height: 50px;
  margin: 0 15px 40px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  text-align: center;

  .btn {
    width: 150px;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    letter-spacing: 5px;
    text-indent: 5px;
  }

  .btn-cancel {
    color: $primary-color-bright;
    background: #fff;
  }

  .btn-edit {
    color: #fff;
    background: linear-gradient(to right, #f2a612, #f7c827);
  }
}
</style>
